// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1WKjy","info":"PatientInfo_info__2uQdG"};